/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessPeriod } from './BusinessPeriod';
import {
    BusinessPeriodFromJSON,
    BusinessPeriodFromJSONTyped,
    BusinessPeriodToJSON,
    BusinessPeriodToJSONTyped,
} from './BusinessPeriod';

/**
 * 
 * @export
 * @interface BusinessServiceAvailabilityOverride
 */
export interface BusinessServiceAvailabilityOverride {
    /**
     * 
     * @type {string}
     * @memberof BusinessServiceAvailabilityOverride
     */
    date: string;
    /**
     * 
     * @type {Array<BusinessPeriod>}
     * @memberof BusinessServiceAvailabilityOverride
     */
    timePeriods: Array<BusinessPeriod>;
}

/**
 * Check if a given object implements the BusinessServiceAvailabilityOverride interface.
 */
export function instanceOfBusinessServiceAvailabilityOverride(value: object): value is BusinessServiceAvailabilityOverride {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('timePeriods' in value) || value['timePeriods'] === undefined) return false;
    return true;
}

export function BusinessServiceAvailabilityOverrideFromJSON(json: any): BusinessServiceAvailabilityOverride {
    return BusinessServiceAvailabilityOverrideFromJSONTyped(json, false);
}

export function BusinessServiceAvailabilityOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessServiceAvailabilityOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'timePeriods': ((json['timePeriods'] as Array<any>).map(BusinessPeriodFromJSON)),
    };
}

export function BusinessServiceAvailabilityOverrideToJSON(json: any): BusinessServiceAvailabilityOverride {
    return BusinessServiceAvailabilityOverrideToJSONTyped(json, false);
}

export function BusinessServiceAvailabilityOverrideToJSONTyped(value?: BusinessServiceAvailabilityOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'timePeriods': ((value['timePeriods'] as Array<any>).map(BusinessPeriodToJSON)),
    };
}

